import * as React from 'react'
import {ICreateGifComponentProps} from "./ICreateGifComponentProps";
import {ICreateGifComponentState} from "./ICreateGifComponentState";
import * as gifshot from 'gifshot'
import MagicDropzone from 'react-magic-dropzone';
import 'src/assets/css/main.css';
import 'src/assets/css/responsive.css';
import FooterComponent from "../footerComponent/FooterComponent";
import MenuComponent from "../menuComponent/MenuComponent";
import HeaderComponent from "src/components/homeHeader/HeaderComponent";
import Loader from 'react-loader-spinner'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Line} from 'rc-progress';
import MenuLeftemobile from "../menuLeftMobile/MenuLeftemobile";

export class CreateGifComponent extends React.Component<ICreateGifComponentProps, ICreateGifComponentState> {


    constructor(props: ICreateGifComponentProps) {
        super(props)
        this.state = {
            value: "image/jpeg, image/png, .jpg, .jpeg, .png , .mp4 ",
            previews: [],
            accepted: [],
            img: '',
            interval: 0.1,
            seek: 0,
            offset: 0,
            numFrames: 0,
            type: '',
            percent: 0,
            youtube: ''
        }
    }

    creategif = () => {
        event.preventDefault()
        let video, time, interval: any
        let image: any
        let images = []

        this.state.accepted.map((v, i) => {
            images.push(v.preview)
        })

        if (this.state.accepted[0].type.split('/')[0] === 'video') {
            video = images
            image = false

            interval = 0.1
        } else {
            video = false
            image = images

            interval = this.state.interval
        }
        gifshot.createGIF(
            {
                gifWidth: 500,
                gifHeight: 500,
                images: image,
                video: video,
                interval: interval,
                offset: this.state.offset,
                numFrames: this.state.numFrames * 10,
                frameDuration: 0.1,
                fontWeight: 'bold',
                fontSize: '40px',
                fontFamily: 'sans-serif',
                fontColor: '#FFFFFF',
                textAlign: 'center',
                textBaseline: 'bottom',
                sampleInterval: 10,
                numWorkers: 2,
                crossOrigin : "anonymous",
                waterMark: null,
                textYCoordinate: 450,
                text: this.state.text,
                progressCallback: (captureProgress) => {
                    this.setState({percent: captureProgress * 100})
                    if (captureProgress * 100 === 100 && this.state.img !== '') {
                        this.setState({percent: 0})
                    }

                },
                completeCallback: (com) => {
                     console.log(com, 'complited')
                },
            }, (obj) => {
                if (!obj.error) {
                    //   var image = obj.image, animatedImage = document.createElement('img');
                    //  animatedImage.src = image;
                    this.setState({img: obj.image, percent: 0})


                    //document.body.appendChild(animatedImage);
                }
            });

    }
    onDrop = (accepted, rejected, links) => {

        let acc = accepted.map(v => acc = v)

        if (this.state.accepted.length > 0)
            console.log(this.state.accepted[0].type.split('/')[0])

        if (this.state.accepted.length == 0) {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,
                type: acc[0].type.split('/')[0]
            });
        }

        if (this.state.accepted.length > 0 && acc[0].type.includes(this.state.type) && this.state.type !== 'video') {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,

            });

        }
        console.log(accepted, 'real 2 ')
        console.log(this.state.type, 'state 2')
    };

    generateyoutubelink = async (url) => {

      let res =    await fetch('https://you-link.herokuapp.com/?url='+url);
      res.json().then(items => {
          if (items[0].sp && items.find( a=> a.sp === 'signature') ){

              toast.error("video protégée !", {
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
              });
          }
           else   if ( items[0].type &&  items.find( a=> a.type.includes('mp4'))   )
          {
              this.setState({
              accepted: [{preview: items.find(a => a.type.includes('mp4')).url, type: 'video/mp4'}],
              type: 'video'
              })
          } else {toast.error("URL  Invalide !", {
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true
              });}
      })
    }
    handleChange = () => {
        let text, interval, time, seek, video, youtube, numFrames: any;
        (() => {
            text = document.querySelector("#text");
            interval = document.querySelector("#interval");
            seek = document.querySelector("#seek-bar");
            video = document.querySelector("#video");
            numFrames = document.querySelector("#numFrames");
            youtube = document.querySelector("#youtube");
        })();

        //console.log(youtube)
        if (youtube && !video)
        {
            if(youtube.value && youtube.value.includes('watch?v')) {
                youtube= youtube.value

                this.generateyoutubelink(youtube)
            }
        }
        if (text)
            text = text.value;
        if (this.state.type === 'video')
            numFrames = numFrames.value
        else
            numFrames = 5
        if (this.state.type === 'video' && video) {
            time = video.duration * (seek.value / 100);

            // Update the video time
            video.currentTime = time;

            seek = (100 / video.duration) * video.currentTime;

        } else {
            time = 0
        }


        if (this.state.type === 'video' && interval)
            interval = interval.value;
        else if (this.state.type === 'video')
            interval = 0.1;
        else
            interval = 0.5;


        this.setState({
            seek: seek,
            text: text,
            interval: interval,
            offset: time,
            numFrames: numFrames
        });
    }
    onRemove = (file) => {
        console.log(file)
        let acc = this.state.accepted.filter(a => a !== file)

        console.log(acc)

        this.setState({
            accepted: acc
        })

        console.log(acc, 'fff')
    }

    public render() {
        const {img, accepted, type, percent} = this.state

        return (


            <div className="">


                <div>

                    <HeaderComponent/>
                    <MenuLeftemobile/>
                    <MenuComponent/>
                    <ToastContainer />

                    <div className='flex' style={{
                        height: 400,
                    }}>
                        <div>
                            {
                                img
                                    ?
                                    <div>
                                        <div onClick={() => this.setState({
                                            img: ''
                                        })}
                                             style={{
                                                 float: 'right',
                                                 backgroundColor: '#999999',
                                                 color: 'white',
                                                 borderRadius: '40%',
                                                 pading: '5px',
                                                 opacity: 0.3
                                             }}>

                                        {/*    <p style={{margin: '5px'}}>edit</p>
                                        */}

                                        </div>
                                        <img src={this.state.img} alt="" style={{
                                            marginTop: 50,
                                            width: 400,
                                            height: 300
                                        }}/>
                                    </div>
                                    :
                                    percent>0 && img === '' ?
                                        <Loader type="Plane" color="#f34c71" height={80} width={80} /> :
                                        <MagicDropzone
                                        style={{
                                            width: 400,
                                            height: 300
                                        }}
                                        className="Dropzone"
                                        accept={this.state.value}
                                        onDrop={this.onDrop}>
                                        <div className="Dropzone-content">
                                            {this.state.accepted.length && this.state.accepted.length > 0 ? (
                                                this.state.accepted.map((v, i) => (
                                                    <div>
                                                        {
                                                            v && v.type && v.type.includes('video') ?

                                                                (
                                                                    this.state.accepted.length === 1 ?
                                                                        <div key={i} className="Dropzone-img-big">
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{
                                                                                     float: 'right',
                                                                                     backgroundColor: '#999999',
                                                                                     color: 'white',
                                                                                     borderRadius: '40%',
                                                                                     pading: '5px',
                                                                                     opacity: 0.3
                                                                                 }}><p style={{margin: '5px'}}>x</p>
                                                                            </div>
                                                                            < video
                                                                                controls

                                                                                controlsList="nodownload noremoteplayback nofullscreen"
                                                                                className="Dropzone-img-big"
                                                                                    src={v.preview} id="video"
                                                                                    onChange={this.handleChange}></video>
                                                                        </div>
                                                                        :
                                                                        <div className="Dropzone-img" key={i}>
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{
                                                                                     float: 'right',
                                                                                     backgroundColor: '#999999',
                                                                                     color: 'white',
                                                                                     borderRadius: '40%',
                                                                                     pading: '5px',
                                                                                     opacity: 0.3
                                                                                 }}><p style={{margin: '5px'}}>x</p>
                                                                            </div>
                                                                            < video autoPlay loop controls
                                                                                    className="Dropzone-img-big"
                                                                                    src={v.preview}></video>
                                                                        </div>
                                                                )
                                                                :
                                                                (
                                                                    v && this.state.accepted.length === 1 ?
                                                                        <div key={i} className="Dropzone-img-big">
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{
                                                                                     float: 'right',
                                                                                     backgroundColor: '#999999',
                                                                                     color: 'white',
                                                                                     borderRadius: '40%',
                                                                                     pading: '5px',
                                                                                     opacity: 0.3
                                                                                 }}><p style={{margin: '5px'}}>x</p>
                                                                            </div>
                                                                            <img className="Dropzone-img-big"
                                                                                 src={v.preview}/>
                                                                        </div> :
                                                                        v ?
                                                                            <div key={i}>
                                                                                <div onClick={() => this.onRemove(v)}
                                                                                     style={{
                                                                                         float: 'right',
                                                                                         backgroundColor: '#999999',
                                                                                         color: 'white',
                                                                                         borderRadius: '40%',
                                                                                         pading: '5px',
                                                                                         opacity: 0.3
                                                                                     }}><p style={{margin: '5px'}}>x</p>
                                                                                </div>
                                                                                <img className="Dropzone-img"
                                                                                     src={v.preview}/>
                                                                            </div> :
                                                                            null
                                                                )
                                                        }
                                                    </div>

                                                ))
                                            ) : (
                                                "Déposez quelques fichiers sur moi!"
                                            )}
                                        </div>
                                    </MagicDropzone>
                            }
                        </div>
                        <div className="tabs-content">


                                {accepted.length > 0 ?
                                    <form style={{
                                        width: 600
                                    }}>
                                        <div className="input_ctrl">
                                            <input placeholder='Text' type="text" value={this.state.text} id='text'
                                                   onChange={this.handleChange}/>
                                        </div>

                                        {type === 'video' ?
                                            <div>
                                                {/*<div className="input_ctrl">
                                                    <input placeholder='interval' name="interval" id="interval"
                                                           value={this.state.interval} step='0.1'
                                                           onChange={this.handleChange} type="number"/>
                                                </div>
                                                 */}
                                                <div className='input_ctrl'>
                                                    <input type="range" id="seek-bar" value={Math.floor(this.state.seek)} min="0"
                                                           onChange={this.handleChange}/>
                                                    <input type="number" value={this.state.offset}
                                                           onChange={this.handleChange}/>
                                                </div>

                                                <div className='input_ctrl'>
                                                    <input type="number" id='numFrames' value={this.state.numFrames}
                                                           onChange={this.handleChange}/>
                                                </div>
                                            </div>
                                            : null}
                                        <div className="input_ctrl">
                                            <button onClick={() => this.creategif()}>Preview
                                            </button>
                                        </div>

                                        {
                                            percent > 0 && img === '' ?
                                                <div>
                                                    <Line percent={percent} strokeWidth="8"
                                                          trailWidth="8"
                                                          strokeLinecap="butt"
                                                          style={{
                                                              width: '60%'
                                                          }} strokeColor="#f34c71"> </Line>
                                                    <h1 style={{
                                                        width: '60%',
                                                        marginLeft: '45%',
                                                        marginTop: '-3.5%'
                                                    }}> {Math.floor(percent)}%
                                                    </h1>
                                                </div>
                                                :
                                                null
                                        }
                                    </form> :
                                    <form
                                        style={{
                                            width: 600
                                        }}
                                        onSubmit={() => {
                                            event.preventDefault();
                                            alert('drop files')
                                        }}>
                                        <div className="input_ctrl">
                                            <input placeholder='Youtube Url' type="text" value={this.state.youtube} id='youtube'
                                                   onChange={this.handleChange}/>
                                        </div>
                                    </form>
                                }
                        </div>
                    </div>
                </div>
                {/*
                <div>
                    <MagicDropzone
                        className="Dropzone"
                        accept={this.state.value}
                        onDrop={this.onDrop}>
                        <div className="Dropzone-content">
                            {this.state.previews.length > 0 ? (
                                this.state.previews.map((v, i) => (

                                    <img key={i} alt="" className="Dropzone-img" src={v}/>
                                ))
                            ) : (
                                "Déposez quelques fichiers sur moi!"
                            )}
                        </div>
                    </MagicDropzone>
                </div>
                <div className="input_ctrl">
                    <input type="text" value={this.state.text} id='text' onChange={this.handleChange}/>
                </div>
                <div>
                    <button onClick={() => this.creategif(this.state.previews, 'aaaaa')}>create Gif</button>
                </div>
                <div>
                    {
                        img

                            ? <img src={this.state.img} alt="" width='200px' height='200px'/>

                            : null
                    }
                </div>*/}
                <FooterComponent/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/createGifComponent/CreateGifComponent.tsx